export default __webpack_public_path__ + "static/sparkle-cta-e1362ab9e90bdee19009b13a3ee18405.svg";